import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { IPBoardHelper } from 'src/app/helpers/ip-board-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import SecondBoard from 'src/app/model/product/ip-board/second-board';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'ip-board-second-board',
  templateUrl: './ip-board-second-board.component.html',
  styleUrls: ['./ip-board-second-board.component.scss'],
})
export class IPBoardSecondBoardComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  @Input()
  project: Project;
  @Input()
  projectPlacement: ProjectPlacement;
  @Input()
  client: boolean = false;
  @Output()
  update = new EventEmitter<any>();

  withSecondBoard: boolean = false;

  placementDiscount: number;

  private emitProjectPlacementVariableChanged = new Subject<any>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeWithSecondBoard();
    this.calculatePlacementDiscount();

    this.addSubscription(
      this.projectDisplayObservableService.getIPBoardConfigurationChangedSubscribable(),
      () => {
        this.calculatePlacementDiscount();
      }
    );
    this.addSubscription(
      this.emitProjectPlacementVariableChanged,
      () =>
        this.projectDisplayObservableService
          .getProjectPlacementVariableChangedSubscribable()
          .next(),
      GeneralHelper.noop,
      500
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.emitProjectPlacementVariableChanged != null) {
      this.emitProjectPlacementVariableChanged.complete();
      this.emitProjectPlacementVariableChanged = null;
    }
  }

  private initializeWithSecondBoard(): void {
    this.withSecondBoard =
      this.projectPlacement.secondBoard != null &&
      (this.projectPlacement.secondBoard.secondBoardCopy != null ||
        !StringHelper.isEmpty(
          this.projectPlacement.secondBoard.secondBoardConfiguration
        ) ||
        !StringHelper.isEmpty(
          this.projectPlacement.secondBoard.secondBoardPlacementInfo
        ));
  }

  private calculatePlacementDiscount(): void {
    if (!CollectionHelper.isPopulated(this.project.products)) {
      this.placementDiscount =
        IPBoardHelper.IP_BOARD_SECOND_BOARD_PLACEMENT_DISCOUNT;
    }
    const firstProduct = this.project.products[0];
    const boardPart = ProductHelper.isIPBoard(firstProduct)
      ? (<IPBoard>firstProduct).boardPart
      : null;
    if (boardPart == null) {
      this.placementDiscount =
        IPBoardHelper.IP_BOARD_SECOND_BOARD_PLACEMENT_DISCOUNT;
    } else {
      this.placementDiscount =
        IPBoardHelper.getSecondBoardPlacementDiscount(boardPart);
    }
  }

  withSecondBoardChanged(): void {
    if (!this.withSecondBoard) {
      this.projectPlacement.secondBoard = null;
    } else if (this.projectPlacement.secondBoard == null) {
      this.projectPlacement.secondBoard = new SecondBoard();
    }
    this.update.emit();
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
  }

  setSecondBoardCopy(value: boolean): void {
    this.projectPlacement.secondBoard.secondBoardCopy = value;
    this.update.emit();
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
  }

  secondBoardConfigurationChanged(value: string): void {
    this.projectPlacement.secondBoard.secondBoardConfiguration = value;
    this.update.emit();
    this.emitProjectPlacementVariableChanged.next();
  }

  secondBoardPlacementInfoChanged(value: string): void {
    this.projectPlacement.secondBoard.secondBoardPlacementInfo = value;
    this.update.emit();
    this.emitProjectPlacementVariableChanged.next();
  }
}
